(function () {
  document.addEventListener("DOMContentLoaded", function () {
    // Function to create our custom header
    function createCustomJudgeMeHeader() {
      // Look for the widget
      const reviewWidget = document.querySelector("#judgeme_product_reviews");
      if (!reviewWidget) return;

      // Check if we already created a custom header
      if (reviewWidget.querySelector(".custom-judgeme-header")) return;

      // Get widget data
      const widgetContainer = reviewWidget.querySelector(".jdgm-rev-widg");
      if (!widgetContainer) return;

      const rating = parseFloat(
        widgetContainer.getAttribute("data-average-rating") || 4.9
      ).toFixed(1);
      const reviewCount =
        widgetContainer.getAttribute("data-number-of-reviews") || "0";

      // Create our custom header
      const customHeader = document.createElement("div");
      customHeader.className = "custom-judgeme-header";

      // Left column - Write review button
      const leftCol = document.createElement("div");
      leftCol.className = "custom-judgeme-col custom-judgeme-left";

      const writeReviewBtn = document.createElement("button");
      writeReviewBtn.className = "custom-judgeme-write-review";
      writeReviewBtn.textContent = "Write a review";
      writeReviewBtn.type = "button";

      writeReviewBtn.addEventListener("click", function () {
        // Find the write review form and show it
        const reviewForm = document.querySelector(".jdgm-form-wrapper");
        if (reviewForm) {
          reviewForm.style.display = "block";
          // Scroll to the form
          reviewForm.scrollIntoView({ behavior: "smooth" });
        } else {
          // Try to trigger the original button as fallback
          const originalBtn = document.querySelector(".jdgm-write-rev-link");
          if (originalBtn) originalBtn.click();
        }
      });

      leftCol.appendChild(writeReviewBtn);

      // Center column - Rating, stars and count
      const centerCol = document.createElement("div");
      centerCol.className = "custom-judgeme-col";

      const ratingEl = document.createElement("div");
      ratingEl.className = "custom-judgeme-rating";
      ratingEl.textContent = rating;

      const starsEl = document.createElement("div");
      starsEl.className = "custom-judgeme-stars";

      // Create the stars
      const fullStars = Math.floor(parseFloat(rating));
      for (let i = 1; i <= 5; i++) {
        const star = document.createElement("span");
        star.textContent = "★";
        if (i <= fullStars) {
          star.style.color = "#222222";
        } else {
          star.className = "empty-star";
        }
        starsEl.appendChild(star);
      }

      const countEl = document.createElement("div");
      countEl.className = "custom-judgeme-count";
      countEl.textContent = reviewCount + " reviews";

      centerCol.appendChild(ratingEl);
      centerCol.appendChild(starsEl);
      centerCol.appendChild(countEl);

      // Right column - Ask question button
      const rightCol = document.createElement("div");
      rightCol.className = "custom-judgeme-col custom-judgeme-right";

      const askQuestionBtn = document.createElement("button");
      askQuestionBtn.className = "custom-judgeme-ask-question";
      askQuestionBtn.textContent = "Ask a question";
      askQuestionBtn.type = "button";

      askQuestionBtn.addEventListener("click", function () {
        // Find the question form and show it
        const questionForm = document.querySelector(
          ".jdgm-question-form-wrapper"
        );
        if (questionForm) {
          questionForm.style.display = "block";
          // Scroll to the form
          questionForm.scrollIntoView({ behavior: "smooth" });
        } else {
          // Try to trigger the original button as fallback
          const originalBtn = document.querySelector(".jdgm-ask-question-btn");
          if (originalBtn) originalBtn.click();
        }
      });

      rightCol.appendChild(askQuestionBtn);

      // Build the header
      customHeader.appendChild(leftCol);
      customHeader.appendChild(centerCol);
      customHeader.appendChild(rightCol);

      // Find where to insert the custom header
      const subtab = widgetContainer.querySelector(".jdgm-subtab");
      if (subtab) {
        // Insert before the subtab to ensure subtab stays below
        widgetContainer.insertBefore(customHeader, subtab);
      } else {
        // Fallback - insert at the beginning
        widgetContainer.insertBefore(customHeader, widgetContainer.firstChild);
      }

      // Fix all empty stars to have correct color
      const allEmptyStars = document.querySelectorAll(
        ".jdgm-star.jdgm--off, .jdgm-star.jdgm-star--empty"
      );
      allEmptyStars.forEach((star) => {
        star.style.color = "#ddd";
      });

      // Fix question/answer background colors
      const answerElements = document.querySelectorAll(
        ".jdgm-ans, .jdgm-rev__reply"
      );
      answerElements.forEach((el) => {
        el.style.backgroundColor = "#F0EAE4";
      });

      // Fix question item background
      const questionItems = document.querySelectorAll(".jdgm-question-item");
      questionItems.forEach((item) => {
        item.style.backgroundColor = "#F0EAE4";
      });

      // Style subtabs like the ask question button
      const subtabs = document.querySelectorAll(".jdgm-subtab__name");
      subtabs.forEach((tab) => {
        tab.style.backgroundColor = "#FFFFFF";
        tab.style.color = "#B88B76";
        tab.style.border = "1px solid #B88B76";
        tab.style.borderRadius = "4px";
        tab.style.margin = "0 5px";
        tab.style.padding = "8px 15px";

        // Add hover event
        tab.addEventListener("mouseenter", function () {
          if (!this.classList.contains("jdgm--active")) {
            this.style.backgroundColor = "#B88B76";
            this.style.color = "#FFFFFF";
          }
        });

        tab.addEventListener("mouseleave", function () {
          if (!this.classList.contains("jdgm--active")) {
            this.style.backgroundColor = "#FFFFFF";
            this.style.color = "#B88B76";
          }
        });

        // Style active tab
        if (tab.classList.contains("jdgm--active")) {
          tab.style.backgroundColor = "#B88B76";
          tab.style.color = "#FFFFFF";
        }
      });
    }

    // Try to create the header immediately
    createCustomJudgeMeHeader();

    // Also observe for changes in case the widget loads later
    const observer = new MutationObserver(function () {
      createCustomJudgeMeHeader();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Disconnect after 10 seconds to prevent memory issues
    setTimeout(() => observer.disconnect(), 10000);
  });
})();
